import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";

const isHapticsAvailable = () => {
    return (
        Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("Haptics")
    );
};

export const safeHapticsImpact = async (
    style: ImpactStyle = ImpactStyle.Medium,
) => {
    if (!isHapticsAvailable()) {
        return;
    }
    try {
        await Haptics.impact({ style });
    } catch (e) {
        // Silently fail - haptics not available in browser
    }
};

export const safeHapticsSelection = async () => {
    if (!isHapticsAvailable()) {
        return;
    }
    try {
        await Haptics.selectionChanged();
    } catch (e) {
        // Silently fail - haptics not available in browser
    }
};

export const safeHapticsNotification = async (type: NotificationType) => {
    if (!isHapticsAvailable()) {
        return;
    }
    try {
        await Haptics.notification({ type });
    } catch (e) {
        // Silently fail - haptics not available in browser
    }
};
